var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.25C7.68804 1.27797 5.47866 2.20883 3.84374 3.84374C2.20883 5.47866 1.27797 7.68804 1.25 10C1.27797 12.312 2.20883 14.5213 3.84374 16.1563C5.47866 17.7912 7.68804 18.722 10 18.75C12.312 18.722 14.5213 17.7912 16.1563 16.1563C17.7912 14.5213 18.722 12.312 18.75 10C18.722 7.68804 17.7912 5.47866 16.1563 3.84374C14.5213 2.20883 12.312 1.27797 10 1.25ZM15 10.625H10.625V15H9.375V10.625H5V9.375H9.375V5H10.625V9.375H15V10.625Z",
    fill: "#020002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFilled);
export default __webpack_public_path__ + "static/media/addFilled.c3d882019a096b0702cbef4ec8a69f21.svg";
export { ForwardRef as ReactComponent };